import React from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function MyModal() {
  const [isOpen, setIsOpen] = React.useState(true);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Our 2026 application period has ended
                  {/* For this application you will need to: */}
                </Dialog.Title>
                <div className="my-2">
                  <p className="text-sm text-gray-500">
                    Dear Carreras Scholarship Applicant,
                    <br />
                    Our 2026 application period has ended and the portal is now
                    closed.
                    <br />
                    We look forward to your application in the year 2027.
                  </p>
                </div>
                {/* <div className="my-2">
                  <ul className="text-sm text-gray-500 list-inside list-disc">
                    <li>Complete application form</li>
                    <li>
                      Upload a copy (certified) of your official Academic
                      Transcript
                    </li>
                    <li>
                      Upload a copy (certified) of your Birth Certificate, or
                      other document showing evidence of your age and
                      nationality (Passport or Driver's License)
                    </li>
                    <li>Upload a copy of your resume</li>
                    <li>
                      Upload evidence of acceptance/enrolment at any recognized
                      University (University ID)
                    </li>
                    <li>Provide details of two (2) referees</li>
                  </ul>
                </div>
                <div className="my-2">
                  <p className="text-sm text-gray-500">
                    Kindly read and carefully complete all sections of this form
                    prior to submitting your application
                  </p>
                </div> */}

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    onClick={closeModal}
                  >
                    Yes
                    {/* Yes, I have read and understood the instructions */}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
